import { render, staticRenderFns } from "./CTRowSettings.vue?vue&type=template&id=1aa121f0&scoped=true"
import script from "./CTRowSettings.vue?vue&type=script&lang=js"
export * from "./CTRowSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa121f0",
  null
  
)

export default component.exports